import { Component, Inject, OnInit } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { WINDOW } from './common/services/injection-tokens';
import { filter } from 'rxjs';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { HeaderComponent } from './core/header/header.component';
import { AppState } from './app.state';
import { select } from '@ngxs/store';
import { LoadingIndicatorComponent } from './common/components/loading-indicator/loading-indicator.component';

@UntilDestroy()
@Component({
  selector: 'app-root',
  imports: [
    HeaderComponent,
    RouterOutlet,
    HeaderComponent,
    LoadingIndicatorComponent,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  constructor(
    private _router: Router,
    @Inject(WINDOW) private _window: Window,
  ) {
  }

  protected appState = select(AppState.get);

  public ngOnInit() {
    this._router.events
      .pipe(
        filter(e => e instanceof NavigationEnd),
        untilDestroyed(this),
      )
      .subscribe(() => {
        this._window?.scrollTo?.(<any>{ top: 0, left: 0, behavior: 'instant' });
      });
  }
}
